import React from "react";
import { FormWidgetContext } from ".";
import { ButtonWidget } from "../button";

import cx from 'classnames';
import styles from './form.module.scss';

const SubmitButtonWidgetComponent = ({ className, style, widgetProps, breakpoint }) => {
  const context = React.useContext(FormWidgetContext);

  const handleClick = () => {
    if(context.onFormSubmit) {
      context.onFormSubmit();
      return;
    }
  }

  return <ButtonWidget 
    widgetProps={widgetProps}
    className={cx(className, styles.submitButton, {
      [style.disabled]: context.submitting
    })}
    key={widgetProps.uid}
    breakpoint={breakpoint}
    style={style}
    onClick={handleClick}
  />
}

const buttonWidgetEquals = function (prevProps, nextProps) {
  const paths = ['className', 'style', 'widgetProps', 'breakpoint', 'onClick'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const SubmitButtonWidget = React.memo(SubmitButtonWidgetComponent, buttonWidgetEquals);
